import { Pipe, PipeTransform } from '@angular/core';
import { formatFullName } from '../helpers';

/** `{{ first_name | fullName: last_name }}` in the order from the company `name_format` setting */
@Pipe({
  name: 'fullName',
  pure: true,
  standalone: false,
})
export class FullNamePipe implements PipeTransform {
  transform(firstName?: string | null, lastName?: string | null): string {
    return formatFullName(firstName, lastName);
  }
}
